import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';
import LoginBackground from './components/LoginBackground';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAdminAuth();

  useEffect(() => {
    // If already authenticated, redirect to admin settings
    if (!loading && isAuthenticated) {
      navigate('/administrative-settings', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Show loading while checking auth status
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background relative flex items-center justify-center p-4">
      {/* Background Elements */}
      <LoginBackground />
      
      {/* Main Login Container */}
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-surface border border-border rounded-2xl shadow-soft-lg p-8">
          {/* Header Section */}
          <LoginHeader />
          
          {/* Login Form */}
          <LoginForm />
          
          {/* Footer Section */}
          <LoginFooter />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;